<script setup lang="ts">
import {ref} from 'vue'
import {useBlogStore} from '@/stores/blog'
import type {Post} from '@/stores/blog'

const blogStore = useBlogStore()
blogStore.fetchPosts()
const blogPosts = ref(blogStore.posts as Post[])

// if there are not posts, lets define a dummy post here
const dummyPosts: Post[] = [
  {
    id: 0,
    title: 'An automated system for remote sensing analysis',
    content:
      'Delivering remote sensing data and expertise for site managers in nuclear decommisioning.'
  },
  {
    id: 1,
    title: 'State of the art techniques',
    content:
      'StARRS uses advanced statistical techniques and AI to draw insight from InSAR, LiDAR, and Multispectral/Optical data.'
  },
  {
    id: 2,
    title: 'Ongoing development',
    content: 'A collaboration between the Imperial College London and EDF Energy.'
  },
  {
    id: 3,
    title: 'Thanks and acknowledgements',
    content:
      'The roots of this project are made possible due to support from\
            Nuclear Waste Services Ltd. (formerly Radioactive Waste Management Ltd.)\
            and the Imperial College London Research Software Engineering team via a UKRI Open Source Booster'
  }
]
// if there are no posts, lets add a dummy post
if (blogPosts.value.length === 0) {
  blogPosts.value.push(...dummyPosts)
}
</script>

<template>
  <div v-for="post in blogPosts" :key="post.id">
    <h2>{{ post.title }}</h2>
    <p>{{ post.content }}</p>
  </div>
</template>
